import { Text } from '@dixa/lib-shared-habla';
import { ConversationAutomationInternalNoteLogEntry } from 'lib-shared-types-api';

export type RoutedThroughInternalNoteProps = {
  node: ConversationAutomationInternalNoteLogEntry;
};

export function RoutedThroughInternalNote(
  _props: RoutedThroughInternalNoteProps,
): JSX.Element {
  return (
    <Text.Paragraph>
      Internal note · Automation visited internal note action
    </Text.Paragraph>
  );
}
